module.exports = __webpack_public_path__ + "static/img/teacher2.f160bac4.png";